// extracted by mini-css-extract-plugin
export default {"container":"Group_container__8nTTU","active_grp":"Group_active_grp__s6bHF"};